export type GroupsListKeyType = 'groups';
export type DriversListKeyType = 'drivers';
export type VehiclesListKeyType = 'vehicles';
export type AssetsListKeyType = 'assets';
export type ModalListKeyType = GroupsListKeyType | DriversListKeyType | VehiclesListKeyType | AssetsListKeyType;

export const GROUPS: GroupsListKeyType = 'groups';
export const DRIVERS: DriversListKeyType = 'drivers';
export const VEHICLES: VehiclesListKeyType = 'vehicles';
export const ASSETS: AssetsListKeyType = 'assets';

export enum ScheduleEntityTypes {
    GROUPS = 'groups',
    DRIVERS = 'drivers',
    VEHICLES = 'vehicles',
    ASSETS = 'assets',
}

export enum ServiceControlTypes {
    LASTSERVICE = 'lastService',
    NEXTSERVICE = 'nextService',
}
